var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "d-flex flex-column ScheduleColumn flex-shrink-0 flex-grow-0 mr-1"
  }, [_c('v-sheet', {
    attrs: {
      "color": "primary white--text mb-1 pa-1 rounded dragMeColumn",
      "elevation": "1",
      "xcontextmenu": "rightClick"
    }
  }, [_c('div', {
    staticClass: "text-subtitle-2 text-center"
  }, [_vm._v(_vm._s(_vm.title))])]), _c('div', {
    staticClass: "flex-grow-1 overflow-y-auto my-1"
  }, [false ? void 0 : _vm._e(), _c('v-virtual-scroll', {
    attrs: {
      "items": [].concat(_vm.tasks, [{
        xid: null
      }]),
      "item-height": "80",
      "bench": "0"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref) {
        var item = _ref.item;
        return [_c('ScheduleTask', {
          staticClass: "mx-1",
          attrs: {
            "task": item
          }
        })];
      }
    }])
  })], 2), _c('v-menu', {
    ref: "menu_rightclick",
    attrs: {
      "position-x": _vm.contextmenu.x,
      "position-y": _vm.contextmenu.y,
      "absolute": "",
      "offset-y": ""
    },
    model: {
      value: _vm.contextmenu.show,
      callback: function callback($$v) {
        _vm.$set(_vm.contextmenu, "show", $$v);
      },
      expression: "contextmenu.show"
    }
  }, [_c('v-list', {
    attrs: {
      "dense": ""
    }
  }, [_c('v-list-item', {
    attrs: {
      "link": ""
    }
  }, [_c('v-icon', {
    staticClass: "mr-2",
    attrs: {
      "color": "primary"
    }
  }, [_vm._v("mdi-circle")]), _vm._v("...")], 1)], 1)], 1), _c('ScheduleTask', {
    staticClass: "mx-1",
    attrs: {
      "task": {
        xid: null
      },
      "xmove": "moveTask"
    }
  }), _c('EditTaskDialog', {
    ref: "editTaskDialog"
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }